/**
 * 申请付款弹窗（BillPayment/billPaymentDialog.vue）发票池收票纯函数集（REQ-0026 T1）。
 *
 * 行为与参照弹窗 BillPaymentByJob/billPaymentDialog.vue 的收票逻辑逐点对齐：
 * 已关联发票守卫字段（invoiceUuid / chargeInvoiceUuid / invoiceNo / chargeInvoiceNo）、
 * 拦截提示文案（jobNo--费用名）、销方名称默认值（首行 chargeInvoiceTitle 回落 invoiceTitle）、
 * 收票后刷新链（rowData 整体替换 + chargesRemoved 乐观锁版本同步）。
 * 抽为纯模块的原因：本仓 Jest 无法 import .vue（vue-jest 的 babel6 桥 × @babel7，
 * 见 PLAN §0），行为级测试只能落在纯函数层。
 */
export function hasInvoicePoolValue(value) {
  return value !== undefined && value !== null && String(value).trim() !== ''
}

export function isChargeAssociatedWithInvoice(row) {
  if (!row) return false
  return hasInvoicePoolValue(row.invoiceUuid) || hasInvoicePoolValue(row.chargeInvoiceUuid) || hasInvoicePoolValue(row.invoiceNo) || hasInvoicePoolValue(row.chargeInvoiceNo)
}

export function buildChargeAssociationLabel(row, resolveChargeItemLabel) {
  const chargeRow = row || {}
  const jobNo = chargeRow.jobJobNo || chargeRow.jobNo || ''
  const chargeName = chargeRow.chargeName || chargeRow.chargeChargeName || chargeRow.chargeItemName || (resolveChargeItemLabel ? resolveChargeItemLabel(chargeRow) : '') || ''
  return `${jobNo}--${chargeName}`
}

export function buildInvoicePoolOpenState(chooseRows) {
  const firstRow = (chooseRows && chooseRows[0]) || {}
  return {
    sellerTaxNameDefaultValue: firstRow.chargeInvoiceTitle || firstRow.invoiceTitle || '',
    selectedEntities: chooseRows || [],
    source: 'invoice',
    operation: 'collection',
    makeInvoiceMethod: 1
  }
}

export function collectChargeUuids(rowData) {
  return [...new Set((rowData || []).map(item => item && item.uuid).filter(Boolean))]
}

export function applyLatestCharges({ chargesRemoved, latestCharges } = {}) {
  const freshCharges = Array.isArray(latestCharges) ? latestCharges : []
  const latestVersionMap = freshCharges.reduce((map, charge) => {
    if (charge && charge.uuid) {
      map[charge.uuid] = charge.version
    }
    return map
  }, {})
  let nextChargesRemoved = chargesRemoved
  if (Array.isArray(chargesRemoved) && chargesRemoved.length > 0) {
    nextChargesRemoved = chargesRemoved.map(charge => {
      if (!charge || !charge.uuid || latestVersionMap[charge.uuid] === undefined) {
        return charge
      }
      return {
        ...charge,
        version: latestVersionMap[charge.uuid]
      }
    })
  }
  return {
    rowData: freshCharges,
    chargesRemoved: nextChargesRemoved
  }
}
